<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('UnitTransaction.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj }} -->

    <b-row class="my-2 ps-3">
        <b-col>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.ScheduledItem[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('UnitTransaction.ScheduledItem') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.NarcoticItem[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('UnitTransaction.NarcoticItem') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.DrugFormulary[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('UnitTransaction.DrugFormulary') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.CriticalMedicine[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('UnitTransaction.CriticalMedicine') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.Alike[0] == 'true'" class='greentick me-3' src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('UnitTransaction.Alike') }}</p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss"></style>